import Component from '../../components/Component';

import keys from './keys';
import query from './query';
import ListData from '../../components/ListData';
import { withTranslation } from 'react-i18next';

class Summary extends Component {
    constructor() {
        super();
        this.query = query;
    }

    componentDidUpdate() {
        if (this.state.data && !this.state.data.length && !this.props.emptyEntities) {
            this.props.setIsEmpty(true);
        }
    }

    render() {
        const { t } = this.props;

        return (
            <ListData
                loading={this.state.loading}
                header={this.props.header ?? t('discover.overview.top_entities.header')}
                subheader={
                    this.props.subheader ?? t('discover.overview.top_entities.default_subheader')
                }
                forceRun={this.forceRun}
                link={this.props.link}
                keys={keys}
                uniqKey="name"
                data={this.state.data}
                cardClassName={'list-data-full'}
            />
        );
    }
}

export default withTranslation()(Summary);
